export const HOURS_LABEL = "Todos os dias, das 9h às 22h";

export const statusLabel = (cfg) => {
  const agent = cfg?.agent_name || "Bia";
  if (cfg?.online) return `${agent} · online agora`;
  if (cfg?.ai) return `${agent} responde agora`;
  return `Atendimento: ${cfg?.hours || HOURS_LABEL}`;
};

export const firstVisitorIndex = (msgs) => msgs.findIndex((m) => m.from === "visitor");
